<template>
  <div :class="$vuetify.breakpoint.mdAndDown ? '' : ''" v-if="!isIOS">
    <v-row no-gutters class="font-weight-bold justify-center" style="background: #1C1632;" align="start">
      <v-col cols="12" class="pa-0" style="max-width: 1240px; width: 100%;">
        <div class="h3 white--text " :class="$vuetify.breakpoint.mdAndDown ? 'px-4 py-2' : 'pt-4 pb-2'">{{ $t(`label.downloadApk`) }}</div>
      </v-col>
    </v-row>
    <v-row no-gutters justify="center" class="mx-0">
      <v-col cols="12" class="download-banner">
        <div v-if="!$vuetify.breakpoint.mdAndDown" class="hidden-sm-and-down d-flex align-center banner-img" @click="downloadApk()">
          <img loading="lazy" :src="`/static/image/banner/desktop_download_banner_background.jpg`" alt="Desktop Background" style="width: 100%; display: block;" />
          <div style="position: absolute; width: 100%;">
            <v-row no-gutters style="max-width: 1240px;" class="ma-auto">
              <v-col cols="7" class="pa-0">
                <img loading="lazy" :src="`/static/image/banner/desktop_download_banner_${language}.png`" alt="Desktop Download Banner" class="hidden-sm-and-down banner-img" @click="downloadApk()" />
              </v-col>
              <v-col cols="5" class="pa-0 right_element_container">
                <img
                  loading="lazy"
                  :src="`/static/image/banner/element_right_${language}.png`"
                  alt="Desktop Download Banner"
                  class="hidden-sm-and-down banner-img right_element"
                  @click="downloadApk()"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <!-- Mobile -->
        <div v-else class="hidden-md-and-up banner-img" @click="downloadApk()">
          <img loading="lazy" :src="`/static/image/banner/mobile_download_banner_${language}.jpg`" alt="Mobile Download Banner" style="width: 100%; display: block;" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { uiHelper } from '@/util'
import { SHARED } from '@/constants/constants'

export default {
  name: 'appHomeDownloadClient',
  data: () => ({
    isIOS: uiHelper.IsIos(),
    currency: SHARED.DEFAULT_CURRENCY.toLowerCase(),
    language: uiHelper.getLanguage()
  }),
  methods: {
    downloadApk() {
      uiHelper.downloadAPK()
    }
  }
}
</script>

<style scoped>
.right_element_container {
  position: relative;
}
.right_element {
  transform: scale(1.15);
  position: absolute;
  right: 80px;
}
.download-banner {
  cursor: pointer;
}

.banner-img {
  //aspect-ratio: 1900/400;
  //background-position-x: center;
  //background-size: cover;
  width: 100%;
}
</style>
